import axios from 'axios';

// Use relative URL for API calls - this ensures the API is always called on the same domain
// When running locally or in preview, REACT_APP_BACKEND_URL can override this
// When deployed to production (tstudios.no), it uses relative /api which goes to tstudios.no/api
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const api = {
  // Get configuration
  getConfig: async () => {
    const response = await axios.get(`${API}/config`);
    return response.data;
  },
  
  // Upload file
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/upload`, formData);
    return response.data;
  },
  
  // Create order
  createOrder: async (orderData) => {
    const response = await axios.post(`${API}/orders`, orderData);
    return response.data;
  },
  
  // Get order
  getOrder: async (orderId) => {
    const response = await axios.get(`${API}/orders/${orderId}`);
    return response.data;
  },
  
  // Create checkout session
  createCheckoutSession: async (orderId, originUrl) => {
    const response = await axios.post(`${API}/checkout/session`, {
      order_id: orderId,
      origin_url: originUrl
    });
    return response.data;
  },
  
  // Get checkout status
  getCheckoutStatus: async (sessionId) => {
    const response = await axios.get(`${API}/checkout/status/${sessionId}`);
    return response.data;
  },

  // Admin: Get all orders
  getOrders: async (limit = 50, skip = 0) => {
    const response = await axios.get(`${API}/orders?limit=${limit}&skip=${skip}`);
    return response.data;
  },

  // Admin: Get order details
  getOrderDetails: async (orderId) => {
    const response = await axios.get(`${API}/orders/${orderId}`);
    return response.data;
  },

  // Admin: Retry Printful order
  retryPrintful: async (orderId) => {
    const response = await axios.post(`${API}/debug/retry-printful/${orderId}`);
    return response.data;
  },

  // Admin: Resend confirmation email
  resendEmail: async (orderId) => {
    const response = await axios.post(`${API}/orders/${orderId}/resend-confirmation`);
    return response.data;
  },

  // Admin: Get debug config
  getDebugConfig: async () => {
    const response = await axios.get(`${API}/debug/config`);
    return response.data;
  },

  // Admin: Get Printful order status
  getPrintfulStatus: async (orderId) => {
    const response = await axios.get(`${API}/printful/order/${orderId}`);
    return response.data;
  },
};

export default api;
